import { FC, useCallback, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
  Box,
  Button,
  FormHelperText} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { submitUserRegister } from '~/actions/register';
import { getRegisterState, State as RegisterState } from '~/reducers/register';
import TermsOfUseText from '../TermsOfUseText';
import OdForm, { OnSubmit } from '~/components/formik/OdForm';
import TextField from '~/components/formik/TextField';
import { useLocation } from 'react-router-dom';


const validationSchema = 
  Yup.object().shape({
    email: Yup.string()
      .email('You must use a valid email address.')
      .noBlockedEmail('Email domain not supported, please use your work email address.')
      .max(255)
      .required('Email is required'),
    firstname: Yup.string().max(50).required('First Name is required'),
    lastname: Yup.string().max(50).required('Last Name is required'),
  })

const RegisterJWT: FC = (props) => {
  const dispatch = useDispatch()
  const location = useLocation<any>()
  const initialEmail : string = (location.state ? location.state['email'] : '') ?? ''

  const initialValues = {
    email: initialEmail,
    firstname: '',
    lastname: '',
    // policy: false,
    submit: null
  }

  const onSubmit: OnSubmit<typeof initialValues> = useCallback((values, bag) => {
    dispatch(submitUserRegister(values.email, values.firstname, values.lastname))
  }, [])
  const formikCtrl = useFormik({ initialValues, onSubmit, validationSchema })
  const { errors, isSubmitting, setSubmitting, setStatus, setErrors } = formikCtrl

  const state : RegisterState = useSelector(getRegisterState)

  useEffect(() => {
    setSubmitting(state.processing)
  
    if (state.email !== undefined) {
      if (state.success === true) {
        setStatus({ success: true })
      } else if (state.success === false) {
        setStatus({ success: false })
        setErrors({ submit: state.resultText })
      }
    }
  }, [state, setStatus, setErrors, setSubmitting])
      
  return (
    <OdForm formikCtrl={formikCtrl}>
      <TextField label="First Name" margin="normal" name="firstname" />
      <TextField label="Last Name" margin="normal" name="lastname" />
      <TextField label="Work Email Address" margin="normal" name="email" type="email" />
      
      <Box sx={{ alignItems: 'center', display: 'flex', ml: -1, mt: 2 }} >
        <TermsOfUseText leadingText="By creating an account, you agree to OnData's" TextProps={{ ml: '2em', mr: '2em' }} />
      </Box>
      {errors.submit && (
        <Box sx={{ mt: 3 }}>
          <FormHelperText error>
            {errors.submit}
          </FormHelperText>
        </Box>
      )}
      <Box sx={{ mt: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          Register
        </Button>
      </Box>
    </OdForm>
  );
};

export default RegisterJWT;
